export const SERVER_OPTIONS = {
  local: process.env.GATSBY_YOUBROKER_SERVER_LOCAL,
  staging: process.env.GATSBY_YOUBROKER_SERVER_STAGING,
  production: process.env.GATSBY_YOUBROKER_SERVER_PRODUCTION,
  demo: process.env.GATSBY_YOUBROKER_SERVER_DEMO,
};

export const SERVER = SERVER_OPTIONS?.[process.env.GATSBY_YOUBROKER_SERVER];
